import { render, staticRenderFns } from "./RealTimeTaskPageContent.vue?vue&type=template&id=079fb6bb&"
import script from "./RealTimeTaskPageContent.vue?vue&type=script&lang=js&"
export * from "./RealTimeTaskPageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports